/**
 * Human-friendly build version for the UI.
 *
 * CI stamps REACT_APP_VERSION with the full build identifier. Release builds
 * are plain (`0.0.2`); pre-release builds carry a channel and commit
 * (`0.0.2-dev.9f2c1ab3`). Screens show the release number plus the channel,
 * dropping the commit hash — so a dev build reads `0.0.2-dev` and is
 * distinguishable at a glance from the released `0.0.2`. The full string
 * stays available as a tooltip for support.
 */
export function toDisplayVersion(rawVersion: string | undefined): string {
  if (!rawVersion) {
    return '';
  }
  const trimmed = rawVersion.trim();
  const suffixStart = trimmed.indexOf('-');
  if (suffixStart === -1) {
    return trimmed;
  }
  const release = trimmed.slice(0, suffixStart);
  const channel = trimmed.slice(suffixStart + 1).split('.')[0];
  return channel ? `${release}-${channel}` : release;
}
